import { StatsApiClient } from "../../clients/stats-client";
import { HeroesMetaPool, HeroesMetaRequest, HeroesMetaResponse } from "./models/heroes";
import { HeroItemBuild } from "./models/item-builds";

export class HeroesRepository {
    private _client: StatsApiClient;

    constructor() {
        this._client = new StatsApiClient('/api/v2/heroes');
    }

    async getAll(): Promise<ApiDataResponse<HeroResponse>> {
        return await this._client.get<HeroResponse>("");
    }

    async getMeta(request: HeroesMetaRequest): Promise<ApiDataResponse<HeroesMetaResponse>> {
        return await this._client.get<HeroesMetaResponse>("meta", {
            period: request.period,
            withTalents: request.withTalents.toString()
        });
    }

    async getItemBuild(heroName: string): Promise<ApiDataResponse<HeroItemBuild>> {
        return await this._client.get<HeroItemBuild>("itembuild", {
            heroName: heroName,
        });
    }
}